export default {
    /**
     * 验证是否为空
     * @param phone 手机号码
     * @returns {boolean}
     */
    checkphoneNull(str) {
        if (!str) {
            return true
        } else {
            return false
        }
    },
    /**
     * 验证姓名是否为空
     * @param userName 用户姓名
     * @returns {boolean}
     */
     checkUserNmaeNull(str) {
        if (!str) {
            return true
        } else {
            return false
        }
    },
    /**
     * 验证码是否为空
     * @param smsCode 验证码
     * @returns {boolean}
     */
    checksmsCodeNull(str) {
        if (!str) {
            return true
        } else {
            return false
        }
    },
    /**
     * 验证码是否正确
     * @param smsCode 验证码
     * @returns {boolean}
     */
    checksmsCode(str) {
        if (/^\d{6}$/.test(str)) {
            return true
        } else {
            return false
        }
    },
    /**
     * 验证姓名格式
     * @param userName 姓名
     * @returns {boolean}
     */
    checkUserName(userName) {
        if (/^[A-Za-z\u4e00-\u9fa5]{1,}$/.test(userName)) {
            return true
        } else {
            return false
        }
    },
    /**
     * 验证手机号格式
     * @param phone 手机号码
     * @returns {boolean}
     */
     checkPhone(phone) {
        if (/^1\d{10}$/.test(phone)) {
            return true
        } else {
            return false
        }
    },
    /**
     * 校验终端跳转
     * @param path 路径
     * @returns {boolean}
     */
    checkTerminal(path) {
        //*********** PC跳转H5 *********//

        //判断是否是PC
        function IsPC() {
            var userAgentInfo = navigator.userAgent;
            var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
            var flag = true;
            for (var v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) {
                    flag = false;
                    break;
                }
            }
            return flag;
        }
        var base_path = '';
        if (window.location.origin == 'https://www.boxuegu.com' || window.location.origin == 'https://m.boxuegu.com') {
            base_path = 'https://m.boxuegu.com/campaign';
        } else {
            base_path = 'https://www.boxuegu.com/campaign';
        }
        if (!IsPC()) {
            if(window.location.host == "portal-ysc.boxuegu.com"){
                window.location.href = "https://m-uat.boxuegu.com/campaign" + `/${path}.html` + window.location.search;
            }else{
                window.location.href = "https://m.boxuegu.com/campaign" + `/${path}.html` + window.location.search;
            }
        } else {
            // window.location.href = "https://www.boxuegu.com/subject" + `/${path}.html` + window.location.search;
        }
    },
    // 获取URL 参数
    getUrlParam(key) {
        var url = window.location.search;
        var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
        var result = url.substr(1).match(reg);
        return result ? decodeURIComponent(result[2]) : null;
    },
    /**
     * 校验终端跳转
     *  * @param path 路径
     */
    checkIsPC() {
        var userAgentInfo = navigator.userAgent;
        var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
            }
        }
        return flag;
    },
    checkBrowser() {

        //*********** 低版本浏览器 不兼容 - 跳转 *********//
        //浏览器判断
        function myBrowser() {
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            var isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
            var isIE =
                userAgent.indexOf("compatible") > -1 &&
                userAgent.indexOf("MSIE") > -1 &&
                !isOpera; //判断是否IE浏览器
            var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
            var isSafari = userAgent.indexOf("Safari") > -1; //判断是否Safari浏览器
            var isChrome = userAgent.indexOf("Chrome") > -1; //判断是否谷歌浏览器
            var isEdge = userAgent.indexOf("Edge") > -1; //判断是否IE的Edge浏览器
            var isQQ =
                userAgent.indexOf("QQBrowser") > -1 &&
                userAgent.indexOf("Chrome") == -1; //QQ浏览器非极速模式

            if (
                userAgent ==
                "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 Edge/18.18363"
            ) {
                window.location.href = "https://www.boxuegu.com/web/html/Download.html";
            }
            if(isEdge){
            	return "Edge";
            }
            if (isIE) {
                var IE5 = (IE55 = IE6 = IE7 = IE8 = false);
                var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
                reIE.test(userAgent);
                var fIEVersion = parseFloat(RegExp["$1"]);
                IE55 = fIEVersion == 5.5;
                IE6 = fIEVersion == 6.0;
                IE7 = fIEVersion == 7.0;
                IE8 = fIEVersion == 8.0;
                IE9 = fIEVersion == 9.0;
                IE10 = fIEVersion == 10.0;
                IE11 = fIEVersion == 11.0;
                if (IE55) {
                    return "IE55";
                }
                if (IE6) {
                    return "IE6";
                }
                if (IE7) {
                    return "IE7";
                }
                if (IE8) {
                    return "IE8";
                }
                if (IE9) {
                    return "IE9";
                }
                if (IE10) {
                    return "IE10";
                }
                if (IE11) {
                    return "IE11";
                }
            } else if (isQQ) {
                return "QQ";
            }
        }
        //以下是调用上面的函数
       let browserArr = ["IE55","IE6","IE7","IE8","IE9","IE10","IE11","QQ","Edge"];
       if(browserArr.indexOf(myBrowser())>-1){
            window.location.href = "https://www.boxuegu.com/web/html/Download.html";
        }
        // //判断是否 360 兼容模式浏览器
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
            window.location.href = "https://www.boxuegu.com/web/html/Download.html";
        }
        if (window.navigator.userAgent.indexOf("QIHU 360EE") > -1) {
            window.location.href = "https://www.boxuegu.com/web/html/Download.html";
        }
    }

}